<template>
    <v-text-field
        v-model.trim="inputValue"
        :label="formattedLabel(question[`label${upperLocale}`], question.required)"
        :aria-label="formattedAriaLabel(question[`label${upperLocale}`], question.required)"
        :rules="(question.required ? [requiredField()] : [])"
        tabindex="0"
    />
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { inputHelpers } from '@/mixins/inputHelpers';

export default {
    name: 'dynamic-text-field',
    props: {
        question: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
            upperLocale: 'upperLocale',
        }),
        inputValue: {
            get() {
                return this.inputValueRaw;
            },
            set(newValue) {
                this.inputValueRaw = newValue;
                this.update(this.inputValueRaw);
            },
        },
    },
    data: () => ({
        dynamicTextFieldResponse: '',
        inputValueRaw: '',
    }),
    mixins: [formRules, inputHelpers],
    methods: {
        update(event) {
            this.$emit('updateQuestionResponse', { 'questionId': this.question.id, 'dynamicResponse': event });
        },
    },
};
</script>
